// Image URLs point at /app/uploads/ on the CMS. CompressX's .htaccess there
// serves the WebP/AVIF version when the browser accepts it and the version
// exists, and the original otherwise. Linking /app/compressx-nextgen/...
// directly gave 404s wherever CompressX skipped a file (sizes over its
// 1920 px limit, files where WebP would not be smaller).
// Images stay on the CMS host: proxied through the front end
// (netlify/edge-functions/cms-media.js) they were several times slower and
// gave 504s under bursts, as its cache is per edge node.
export const toUploadsUrl = url =>
  url.replace(
    /\/app\/compressx-nextgen\/uploads\/([^\s,"']+?)\.(?:webp|avif)(?=[\s,"']|$)/g,
    "/app/uploads/$1"
  )

// "url 300w, url 768w" -> [{ url, width }]
export const parseSrcSet = srcSet =>
  toUploadsUrl(srcSet)
    .split(",")
    .map(entry => entry.trim().split(/\s+/))
    .filter(([url]) => url)
    .map(([url, descriptor]) => ({
      url,
      width: descriptor?.endsWith("w") ? parseInt(descriptor, 10) : null,
    }))
